import vconst from "utils/helpers/structs/vconst";
import TableEmptyRow from "components/others/TableEmptyRow";
import { useObjectCard } from "../../context/ObjectCardProvider";
import ExpendTeamActions from "./ExpendTeamActions";
import { useTranslation } from "react-i18next";
import { CountBadge, ProductOperPrice } from 'modules/warehouse';
import { isOtherTeamIncome } from '../../model/isOtherTeamIncome';
import { tDirName } from 'utils/helpers/i18n/tDirName';
import WorkerSharePie from '../../OffExpendTeamInfo/WorkersTable/WorkerSharePie';

const allocPercent = (allocated, incomeAmount) => {
    const allocatedAmount = Number(allocated) || 0;
    const income = Number(incomeAmount) || 0;
    if (income > 0) return Math.round((allocatedAmount / income) * 1000) / 10;
    return allocatedAmount > 0 ? 100 : 0;
};
 
const ExpendTeamTableBody = ({setShowSpinnerExpendTeam, setShowExpendInfo, isOther = false, showExpendType = false, showAllocation = false, checkedIds = [], setCheckedIds}) => {

    const { t } = useTranslation(['Objects']);
    const { vObject } = useObjectCard();

    const rows = (vObject?.expendTeams || []).filter((expend) =>
        isOther ? isOtherTeamIncome(expend) : !isOtherTeamIncome(expend),
    );

    return (
        <tbody>
            {rows.map(expend=>{
                const serviceName = expend.income_name || expend.incomeName || '';
                const expendTypeId = Number(expend.expend_type_id ?? expend.expendTypeId ?? 0);
                const expendTypeLabel = expendTypeId
                    ? tDirName(t, expend.expend_type_i18n_key, expend.expend_type_name)
                    : '';
                const count = Number(expend.income_count ?? expend.incomeCount ?? 1) || 1;
                const priceOp = {
                    operPrice: Number(expend.income_price ?? expend.incomePrice ?? expend.income_amount ?? 0),
                    operPriceRate: Number(expend.income_price_rate ?? expend.incomePriceRate ?? expend.income_amount_rate ?? 0),
                    operPriceSale: Number(expend.income_price_sale ?? expend.incomePriceSale ?? 0),
                    operPriceSaleRate: Number(expend.income_price_sale_rate ?? expend.incomePriceSaleRate ?? 0),
                };
                return (
                    <tr className={`${expend.income_status === vconst.incomeStatCancel ? 'bg-light-danger' :''}`}
                        key={expend.ID}>
                        <td className="check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={checkedIds.includes(expend.ID)}
                                onChange={(e) => {
                                    setCheckedIds?.((prev) => {
                                        if (e.target.checked) return [...prev, expend.ID];
                                        return prev.filter((id) => id !== expend.ID);
                                    });
                                }}
                            />
                        </td>
                        <td
                            className="service cursor-pointer"
                            onClick={() => setShowExpendInfo(expend.ID)}
                        >
                            <h6 className="mb-1 text-break">{serviceName || '—'}</h6>
                            <p className="text-muted f-12 mb-0 my-1 text-truncate">{expend.team_name || t('fieldsService.noTeam')}</p>
                        </td>
                        {showExpendType ? (
                            <td className="expend-type">
                                {expendTypeLabel ? (
                                    <span className="text-truncate d-block" title={expendTypeLabel}>{expendTypeLabel}</span>
                                ) : (
                                    <span className="text-muted">—</span>
                                )}
                            </td>
                        ) : null}
                        <td className="price">
                            <ProductOperPrice showSalePrice operation={priceOp}/>
                            <div className="d-block d-md-none mt-2">
                                <CountBadge fs={12} count={count}/>
                            </div>
                        </td>
                        <td className="count text-truncate">
                            <CountBadge fs={14} count={count}/>
                        </td>
                        <td className="amount">
                            <ProductOperPrice
                                showSalePrice
                                operation={{
                                    operPrice: priceOp.operPrice * count,
                                    operPriceSale: priceOp.operPriceSale * count,
                                }}/>
                        </td>
                        {showAllocation ? (
                            <td className="share">
                                <WorkerSharePie
                                    percent={allocPercent(
                                        expend.workers_amount ?? expend.workersAmount,
                                        expend.income_amount ?? expend.incomeAmount,
                                    )}
                                />
                            </td>
                        ) : null}
                        <td className="actions">
                            <ExpendTeamActions
                                setShowExpendInfo={setShowExpendInfo}
                                setShowSpinnerExpendTeam={setShowSpinnerExpendTeam}
                                expend={expend}/>
                        </td>
                    </tr>
                )
            })}

            {rows.length === 0 && (
                <TableEmptyRow colSpan={(showExpendType ? 7 : 6) + (showAllocation ? 1 : 0)} />
            )}
        </tbody>
    )
}

export default ExpendTeamTableBody;
